import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Tokenomics from "@/components/landing/Tokenomics";
import Roadmap from "@/components/landing/Roadmap";
import Giveaway from "@/components/landing/Giveaway";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="relative bg-[#030014]">
            <Header />
            <Hero />
            <Features />
            <Tokenomics />
            <Roadmap />
            <Giveaway />
            <Footer />
        </main>
    );
}
